import { render, staticRenderFns } from "./LeaderBoardComponent.vue?vue&type=template&id=006064b0&"
import script from "./LeaderBoardComponent.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardComponent.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoardComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports